import {DiagnosticReportId} from '@legit.health/ui';
import {DomainEvent} from '@/shared/contexts/EventDispatcherContext';

export const DIAGNOSTIC_REPORT_MARKED_AS_REVIEWED = 'diagnosticReport.marked_as_reviewed';

export interface DiagnosticReportMarkedAsReviewedEvent extends DomainEvent {
  name: string;
  diagnosticReportId: DiagnosticReportId;
}

export function createDiagnosticReportMarkedAsReviewedEvent(
  diagnosticReportId: DiagnosticReportId
): DiagnosticReportMarkedAsReviewedEvent {
  return Object.freeze({
    name: DIAGNOSTIC_REPORT_MARKED_AS_REVIEWED,
    diagnosticReportId
  });
}
